// Tiny bootstrap — keeps the team-picker render off the critical
// parse path. All the heavy systems (Three.js scene, PartyKit client,
// HUD, audio engine, lobby, match) live in ./app.ts and stream in
// via dynamic import() once the picker resolves. Vite code-splits at
// the import boundary, so a juror's first paint pays only for this
// module + the team-picker dependencies.
import { CONFIG } from './config';
import { getDeviceId } from './progression';
import { installCrashHandler } from './boot/crash';
import { installAudioUnlock } from './audio/synth';
import { promptTeam } from './ui/team_picker';
import { startIntroPrefetch } from './boot/progressive_loader';

const app = document.getElementById('app')!;
// Mark the body with the active theme id BEFORE any UI renders so
// theme-scoped CSS selectors (body[data-theme="y2k"] …) apply to the
// intro card, team picker, and any other boot-time overlays. Full
// resolution happens in `getActiveTheme()` later; this is a fast
// localStorage/URL read to unblock styling.
(() => {
  const qp = new URL(location.href).searchParams.get('theme');
  const ls = (() => { try { return localStorage.getItem('smp.theme'); } catch { return null; } })();
  document.body.dataset.theme = qp ?? ls ?? 'y2k';
})();
const deviceId = getDeviceId();
console.info(`[smp] v${CONFIG.VERSION} — device=${deviceId.slice(0, 8)} solo=${CONFIG.SOLO}`);
installCrashHandler();
installAudioUnlock();
promptTeam(app, deviceId, (name, role) => {
  import('./app').then(({ startApp }) => startApp(name, role)).catch((err) => {
    console.error('[smp] failed to load app chunk', err);
  });
});

// Defer the background prefetch one frame so the team picker paints
// first. Heavy lobby/match modules then stream in while the intro
// animates — they arrive warm in the browser cache before the player
// finishes picking a faction. `requestIdleCallback` is used where
// available so the fetch yields to pending user input.
const kickoff = (): void => startIntroPrefetch();
if ('requestIdleCallback' in window) {
  (window as { requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void })
    .requestIdleCallback(kickoff, { timeout: 1500 });
} else {
  setTimeout(kickoff, 200);
}
